import { render, staticRenderFns } from "./goods-order.vue?vue&type=template&id=26d7af3c&"
import script from "./goods-order.vue?vue&type=script&lang=js&"
export * from "./goods-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports